import { NgxsModule } from '@ngxs/store';
import { ScopeBodyClassService } from './scope-body-class.service';
import { ScopeState } from './scope.state';
import * as i0 from "@angular/core";
import * as i1 from "./scope-body-class.service";
import * as i2 from "@ngxs/store";
export let CoreScopeModule = /*#__PURE__*/(() => {
  class CoreScopeModule {
    // required to make sure services are instantiated
    constructor(scope) {}
    static {
      this.ɵfac = function CoreScopeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CoreScopeModule)(i0.ɵɵinject(i1.ScopeBodyClassService));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: CoreScopeModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [NgxsModule.forFeature([ScopeState])]
      });
    }
  }
  return CoreScopeModule;
})();